import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'

import * as SociosCrud from 'services/socio.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  tipoDocumento: Yup.string().required(),
  numeroDocumento: Yup.string()
    .required()
    .when('tipoDocumento', {
      is: TiposDeDocumentoIdentificacionConstant.DNI,
      then: Yup.string().min(8).max(8),
      otherwise: Yup.string().when('tipoDocumento', {
        is: TiposDeDocumentoIdentificacionConstant.RUC,
        then: Yup.string().min(11).max(11)
      })
    }),
  nombres: Yup.string().when('tipoDocumento', {
    is: TiposDeDocumentoIdentificacionConstant.DNI,
    then: Yup.string().min(3).max(100).required()
  }),
  apellidos: Yup.string().when('tipoDocumento', {
    is: TiposDeDocumentoIdentificacionConstant.DNI,
    then: Yup.string().min(3).max(100).required()
  }),
  razonSocial: Yup.string().when('tipoDocumento', {
    is: tipoDocumento => tipoDocumento !== TiposDeDocumentoIdentificacionConstant.DNI,
    then: Yup.string().min(3).max(200).required()
  }),
  direccion: Yup.string().min(5).max(200).notRequired()
})

const NuevoClienteModal = ({ handleClose, show, onCreate, defaultData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    let numeroDocumento = ''
    if (defaultData && /^[0-9]{11}$/.test(defaultData.numeroDocumento)) {
      numeroDocumento = defaultData.numeroDocumento
    }

    return {
      tipoDocumento: TiposDeDocumentoIdentificacionConstant.RUC,
      numeroDocumento: numeroDocumento,
      nombres: '',
      apellidos: '',
      razonSocial: '',
      direccion: ''
    }
  }, [defaultData])

  const submitHandler = async nuevoSocioData => {
    SociosCrud.nuevoSocioViaVentas(nuevoSocioData)
      .then(({ data }) => {
        __zariContext.snack('success', 'El registro se ha completado.')
        onCreate(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>NUEVO CLIENTE</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={formInitialValues}
        onSubmit={submitHandler}
        validationSchema={ValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, touched, values, handleChange, setValues }) => (
          <Form>
            <Modal.Body>
              <FormGroups.TipoDocumentoFormGroup
                iError={errors.tipoDocumento}
                iTouched={touched.tipoDocumento}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NumeroDocumentoFormGroup
                handleChange={handleChange}
                setValues={setValues}
                values={values}
                iError={errors.numeroDocumento}
                iTouched={touched.numeroDocumento}
                fIsSubmitting={isSubmitting}
              />
              {values.tipoDocumento === TiposDeDocumentoIdentificacionConstant.DNI ? (
                <>
                  <FormGroups.NombresFormGroup
                    iError={errors.nombres}
                    iTouched={touched.nombres}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.ApellidosFormGroup
                    iError={errors.apellidos}
                    iTouched={touched.apellidos}
                    fIsSubmitting={isSubmitting}
                  />
                </>
              ) : (
                <FormGroups.RazonSocialFormGroup
                  iError={errors.razonSocial}
                  iTouched={touched.razonSocial}
                  fIsSubmitting={isSubmitting}
                />
              )}
              <FormGroups.DireccionFormGroup
                iError={errors.direccion}
                iTouched={touched.direccion}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevoClienteModal)
